export const modalState = {
  modalProps: {}
};
